export function onPressEscape( callback: EventListener ) {
    document.addEventListener( 'keydown', ( event: KeyboardEvent ) => {
        if ( event.key === 'Escape' ) {
            callback( event );
        }
    } );
}
